import script from "./user-details-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-details-section.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__